import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { LanguageProvider } from '@/i18n'

// PWA Service Worker registration
if ('serviceWorker' in navigator) {
  import('virtual:pwa-register').then(({ registerSW }) => {
    const updateSW = registerSW({
      immediate: true,
      onNeedRefresh() {
        const isWidget = window.location.pathname.startsWith('/booking/') ||
                         window.location.pathname.startsWith('/widget/');
        if (!isWidget) {
          updateSW(true);
        } else {
          console.log('SW update deferred (widget active)');
        }
      },
      onOfflineReady() {
        console.log('Hotel3D ready to work offline');
      },
      onRegisterError(error) {
        console.error('SW registration error:', error);
      }
    });
  });
}

createRoot(document.getElementById("root")!).render(
  <LanguageProvider>
    <App />
  </LanguageProvider>
);
